import { ActivityLogList } from '../../../components/Report';

export function ActivityLogs() {
  return <ActivityLogList />;
}
